import React, { FC } from 'react'
import { CarIcon } from './types'
import { TransferSearchResult } from '../../hooks/useTransfers/types'
import pluralize from 'pluralize'
import { formatCurrency } from '../../common'
import Icons from '../Icons'
import { carIconToComponent } from './index'

export interface Props {
  icon: CarIcon
  title: string
  results: TransferSearchResult[]
  onSelected?: (result: TransferSearchResult) => void
}

const TransferSearchResultList: FC<Props> = ({ icon, title, results, onSelected }) => {
  const Icon = carIconToComponent(icon)

  return (
    <section className="transfer-result-list">
      <header className="transfer-result-list__header">
        <p className="transfer-result-list__icon">
          <Icon />
        </p>
        <p className="transfer-result-list__title">{title}</p>
        <p className="transfer-result-list__subtitle">
          {`${results.length} ${pluralize('option', results.length)} available`}
        </p>
      </header>
      {results.map((result) => (
        <div key={result.booking_id} className="transfer-result-list__item" onClick={() => onSelected?.(result)}>
          <div className="transfer-result-list__item__content">
            <p className="transfer-result-list__item__title">{result.vehicle_make || `${title} vehicle`}</p>
            <p className="transfer-result-list__item__subtitle">{result.company}</p>
            <p className="transfer-result-list__item__price">£{formatCurrency(result.price)}</p>
          </div>
          <div className="transfer-result-list__item__action">
            <Icons.Arrow />
          </div>
        </div>
      ))}
    </section>
  )
}

export default TransferSearchResultList
